import * as React from "react";
const SvgFiRrGuitar = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="#062147" clipPath="url(#fi-rr-guitar_svg__a)">
      <path d="M10 16a2 2 0 1 0 0-4 2 2 0 0 0 0 4M5.707 16.293a1 1 0 0 0-1.414 1.414l2 2a1 1 0 1 0 1.414-1.414z" />
      <path d="M23.483.518a1.767 1.767 0 0 0-2.5 0l-.215.214a6.03 6.03 0 0 0-1.533 2.62l-2.976 2.975a5.894 5.894 0 0 0-7.7.232q-.24.239-.445.508a2.28 2.28 0 0 1-1.554.96 7.06 7.06 0 0 0-4.5 2.037c-2.956 2.957-2.7 8.025.575 11.3A8.8 8.8 0 0 0 8.815 24a7.16 7.16 0 0 0 5.122-2.059 7.06 7.06 0 0 0 2.038-4.5 2.28 2.28 0 0 1 .958-1.554 5 5 0 0 0 .509-.445 5.9 5.9 0 0 0 .232-7.7l2.974-2.975a6.04 6.04 0 0 0 2.62-1.534l.215-.214a1.767 1.767 0 0 0 0-2.5m-7.456 13.51a3 3 0 0 1-.3.264 4.2 4.2 0 0 0-1.745 2.99 5.07 5.07 0 0 1-1.457 3.24c-2.175 2.174-5.976 1.92-8.469-.575S1.3 13.655 3.48 11.48a5.07 5.07 0 0 1 3.24-1.458 4.2 4.2 0 0 0 2.99-1.745 3 3 0 0 1 .264-.3A3.4 3.4 0 0 1 12.42 7c.861.011 1.7.272 2.415.752l-1.54 1.541a1 1 0 1 0 1.413 1.414l1.538-1.538a3.86 3.86 0 0 1-.218 4.858" />
    </g>
    <defs>
      <clipPath id="fi-rr-guitar_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrGuitar;
